/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterTSmall = createReactComponent("outline", "letter-t-small", "IconLetterTSmall", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }]]);

export { IconLetterTSmall as default };
//# sourceMappingURL=IconLetterTSmall.mjs.map
